<template>
    <base-layout>
        <h1 slot="header">
            {{ `app.pages.orders` | trans}}
        </h1>
        <v-app id="vuetify-app">
            <v-container fluid>
                <v-layout row wrap align-center>
                    <v-flex xs12 d-flex>
                        <order-form
                                method="PATCH"
                                :model="model"
                                @closed="model = null"
                        ></order-form>
                    </v-flex>
                </v-layout>
              <v-layout row wrap align-center>
                <v-flex xs12 d-flex>
                  <invoice-form
                      method="PATCH"
                      :model="invoice"
                      @closed="invoice = null"
                  ></invoice-form>
                </v-flex>
              </v-layout>
                <v-layout row justify-end>
                    <v-flex xs2 pa-2>
                        <v-menu
                                v-model="cal"
                                :close-on-content-click="true"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                        v-model="invoice_month"
                                        readonly
                                        clearable
                                        single-line
                                        hide-details
                                        solo
                                        :label="trans('app.month')"
                                        v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="invoice_month" @input="cal = false" locale="pl-pl"
                                           type="month"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs2 d-flex pa-2>
                        <loading-button :loading="isLoading" :status="status" @click="downloadInvoices()"
                                        :disabled="invoice_month === null">
                            {{ 'app.download_invoices' | trans }}
                        </loading-button>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex pa-2>
                        <v-text-field
                                v-model="filters.id"
                                append-icon="search"
                                :label="trans('app.id')"
                                single-line
                                clearable
                                hide-details
                                solo
                        ></v-text-field>
                    </v-flex>
                    <v-flex pa-2>
                        <v-combobox
                                clearable
                                :items="[{text: trans('page.orders.open'), value: 'open'},{text: trans('page.orders.closed'), value: 'closed'},{text: trans('page.orders.canceled'), value: 'canceled'},{text: trans('page.orders.pending'), value: 'pending'},{text: trans('page.orders.rejected'), value: 'rejected'}]"
                                :label="trans('app.status')"
                                v-model="filters.status"
                                hide-details
                                solo
                        ></v-combobox>
                    </v-flex>
                    <v-flex pa-2>
                        <v-menu
                                v-model="menu"
                                :close-on-content-click="true"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                        v-model="filters.date"
                                        readonly
                                        clearable
                                        single-line
                                        hide-details
                                        solo
                                        :label="trans('app.created_at')"
                                        v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="filters.date" @input="menu = false" locale="pl-pl"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 sm6 md6 pa-2>
                        <v-combobox
                                attach
                                clearable
                                :items="subscriptionTypes"
                                :label="trans('app.subscription')"
                                v-model="filters.subscription"
                                hide-details
                                solo
                        ></v-combobox>
                    </v-flex>
                    <v-flex xs12 sm6 md6 pa-2>
                        <v-text-field
                                v-model="filters.query"
                                append-icon="search"
                                :label="trans('app.search.search')"
                                single-line
                                hide-details
                                clearable
                                solo
                        ></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row wrap align-start>
                  <v-flex xs12>
                        <resource-table ref="table" endpoint="/administrator/orders" :headers="headers"
                                        :filters="filters">
                            <template #content="{item}">
                                <tr :class="{'unconfirmed-order': isUnconfirmed(item)}">
                                    <td>
                                        {{ item.id }}
                                    </td>
                                    <td>
                                        {{ item.created_at }}
                                    </td>
                                    <td>
                                        {{ item.paid_at }}
                                    </td>
                                    <td>
                                        {{ item.userName }}
                                    </td>
                                    <td>
                                        {{ item.userEmail }}
                                    </td>
                                    <td>
                                        {{ item.subscriptionName }}
                                    </td>
                                    <td>
                                        {{ item.amount | money }}
                                    </td>
                                    <td v-if="item.discount !== null">
                                        {{ item.discount | money }}
                                    </td>
                                    <td v-else-if="item.estimated_discount !== null">
                                        {{ item.estimated_discount | money }}
                                    </td>
                                    <td v-else>
                                        -
                                    </td>
                                    <td>
                                        {{ item.with_discount | money }}
                                    </td>
                                    <td>
                                        {{ trans('page.orders.' + item.status) }}
                                    </td>
                                    <td class="justify-end layout px-0 pr-4">
                                        <v-tooltip top>
                                            <template #activator="{ on }">
                                                <v-btn
                                                        v-on="on"
                                                        flat
                                                        icon
                                                        color="green"
                                                        class="mr-0 ml-0"
                                                        @click="editItem(item)">
                                                    <v-icon small>edit</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>{{ 'app.edit' | trans}}</span>
                                        </v-tooltip>
                                        <v-tooltip top>
                                          <template #activator="{ on }">
                                            <v-btn
                                                v-on="on"
                                                flat
                                                icon
                                                color="blue"
                                                class="mr-0 ml-0"
                                                @click="editInvoice(item)"
                                                v-if="item.status === 'closed'">
                                              <v-icon small>edit</v-icon>
                                            </v-btn>
                                          </template>
                                          <span>{{ 'app.invoice.edit' | trans}}</span>
                                        </v-tooltip>
                                        <v-tooltip top>
                                            <template #activator="{ on }">
                                                <v-btn
                                                        v-on="on"
                                                        flat
                                                        icon
                                                        color="green"
                                                        class="mr-0 ml-0"
                                                        :disabled="isLoading"
                                                        @click="downloadInvoice(item)"
                                                        v-if="item.status === 'closed'">
                                                    <v-icon small>description</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>{{ 'app.invoice.invoice' | trans}}</span>
                                        </v-tooltip>
                                        <v-tooltip top>
                                            <template #activator="{ on }">
                                                <v-btn
                                                        v-on="on"
                                                        flat
                                                        icon
                                                        color="blue"
                                                        class="mr-0 ml-0"
                                                        @click="confirmPayment(item)"
                                                        v-if="item.status === 'open' || item.status === 'pending'">
                                                    <v-icon small>payment</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>{{ 'app.confirm_payment' | trans}}</span>
                                        </v-tooltip>
                                        <v-tooltip top v-if="item.status !== 'closed'">
                                            <template #activator="{ on }">
                                                <v-btn
                                                        v-on="on"
                                                        flat
                                                        icon
                                                        color="red"
                                                        class="mr-0 ml-0"
                                                        @click="deleteItem(item)">
                                                    <v-icon small>delete</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>{{ 'app.delete' | trans}}</span>
                                        </v-tooltip>
                                    </td>
                                </tr>
                            </template>
                        </resource-table>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </base-layout>
</template>

<script>
    import {trans} from '../../../app';
    import {mapGetters, mapState} from 'vuex';

    export default {

    data: () => ({
      items: [],
      isLoading: false,
      status: '',
      model: null,
      invoice: null,
      menu: false,
      cal: false,
      invoice_month: null,
      filters: {
        query: null,
        id: null,
        status: null,
        date: null,
        subscription: null,
      },
      headers: [
        {
          text: trans('app.id'), align: 'left', value: 'id', sortable: true,
        },
        {
          text: trans('app.created_at'), align: 'left', value: 'created_at', sortable: true,
        },
        {
          text: trans('app.paid_at'), align: 'left', value: 'paid_at', sortable: true,
        },
        {
          text: trans('app.name'), align: 'left', value: 'userName', sortable: false,
        },
        {
          text: trans('app.email'), align: 'left', value: 'userEmail', sortable: false,
        },
        {
          text: trans('app.subscription'), align: 'left', value: 'subscriptionName', sortable: false,
        },
        {
          text: trans('app.amount'), align: 'left', value: 'amount', sortable: true,
        },
        {
          text: trans('app.discount'), align: 'left', value: 'discount', sortable: true,
        },
        {
          text: trans('app.with_discount'), align: 'left', value: 'with_discount', sortable: false,
        },
        {
          text: trans('app.status'), align: 'left', value: 'status', sortable: true,
        },
        {
          text: '', align: 'center', value: '', sortable: false,
        },
      ],
      pagination: {},
      errors: {},
    }),

    mounted () {
      this.$root.$on('stored', this.$refs.table.fetchData);
    },
    computed: {
      ...mapGetters(['hasPermission']),
      ...mapState(['dictionaries']),
      subscriptionTypes () {
        return this.dictionaries.subscriptions.map(({ id, name, price, duration }) => ({
          text: this.prepareSubscriptionName(name, price, duration),
          value: id,
        }));
      },
    },
    methods: {
      editItem (item) {
        this.model = { ...item };
      },
      prepareSubscriptionName(name, price, duration) {
        if (price && duration) {
          return `${name} (${duration} dni, ${price} zł)`;
        }

        return name;
      },
      async deleteItem (item) {
        const confirm = await this.$confirm(
          trans('app.confirm_removal'), {
            title: trans('app.remove') + ' ' + trans('app.pages.orders').toLowerCase(),
          });

        if (confirm) {
          await axios.delete('/administrator/orders/' + item.uuid);
          this.$refs.table.fetchData();
          this.$toast(trans('app.removed'));
        }
      },

      async downloadInvoice (item) {
        axios.post('/administrator/orders/' + item.uuid + '/createInvoicePdf')
            .then(() => {
              this.isLoading = true;
            })
            .catch(error => {
              this.isLoading = false;
              this.sentryCaptureException(error);
            })
      },

      downloadInvoices () {
        this.isLoading = true;
        const [year, month] = this.invoice_month.split('-');

        axios.post(`/administrator/orders/invoice/${year}/${month}`)
        .catch((error) => {
          this.sentryCaptureException(error);
          this.isLoading = false;
          this.status = false;
        })
      },

      async confirmPayment (item) {
        const confirm = await this.$confirm(
          trans('app.confirm_payment'), {
            title: trans('app.confirm_payment'),
          });
        if (confirm) {
          await axios.get('/administrator/orders/' + item.uuid + '/confirmPayment');
          this.$refs.table.fetchData();
          this.$toast(trans('app.order_confirmed'));
        }
      },
      editInvoice(item) {
        axios.get('/administrator/orders/' + item.uuid + '/invoice')
        .then((response) => {
          this.invoice = response.data.data;
        })
        .catch((error) => {
          this.sentryCaptureException(error);
        })
      },
      isUnconfirmed(item) {
        return item.subscription_type_role_to_assign === 'dietitian_student' && item.student_status_verified === 0 && item.status === 'open';
      },
    },
    async created() {
      setTimeout(()=> {
        window.Echo.private('invoices-archive-created-' + window.user.id)
            .listen('InvoicesArchiveCreatedEvent', (e) => {
              axios.get(e.url, {
                headers: {
                  'Accept': 'application/zip',
                },
                responseType: 'arraybuffer',
              }).then(({data}) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', 'invoice.zip');
                document.body.appendChild(link);
                link.click();
                link.remove();
                this.status = true;
                this.isLoading = false;
              }).catch((error) => {
                this.isLoading = false;
                this.status = false;

                if (error.response && error.response.status === 404) {
                  this.$toast(trans('app.no_invoices'));
                } else {
                  this.sentryCaptureException(error);
                }
              });
            });
      }, 1000);
      setTimeout(() => {
        window.Echo.private('invoice-pdf-created-' + window.user.id)
            .listen('InvoicePdfCreatedEvent', (e) => {
              axios.get(e.url, {
                responseType: 'arraybuffer',
              }).then(({data}) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', e.fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();
                this.isLoading = false;
              }).catch((error) => {
                this.isLoading = false;
                this.sentryCaptureException(error);
              });
            });

      }, 1000);
    }
  };
</script>
<style >
  .unconfirmed-order {
    background-color: #ffacac;
  }
</style>
